import EditPageDialog from "../../../components/edit-page.dialog";
import { FormItem, FormType } from "../../../components/form/form-generator";
import { FileUploadCategory } from "../../../services/file-upload.service";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { updateFuturePage } from "../apis/future-page.api";
import { FuturePageDetailsEntity } from "../entities/future-page-details.entity";
import { FuturePageEditEntity } from "../entities/future-page-edit.entity";
import { FuturePageEditModel } from "../models/future-page-edit.model";

const formElements: FormItem[] = [
  {
    title: "Year",
    contentKey: "pageYear",
    type: FormType.number,
  },
  {
    title: "Description",
    contentKey: "description",
    type: FormType.textArea,
  },
];

export default function EditFuturePageDialog({
  open,
  setOpen,
  futurePage,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  futurePage: FuturePageDetailsEntity;
}) {
  const setAlert = useDashboardStore((state) => state.setAlert);
  const onSave = async (values: any) => {
    updateFuturePage(FuturePageEditModel.fromEntity(values))
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setAlert({
          message: error.response.data.message,
          type: AlertType.error,
        });
      });
  };

  return (
    <EditPageDialog
      title="Edit Future Page"
      open={open}
      setOpen={setOpen}
      page={FuturePageEditEntity.fromDetailsEntity(futurePage)}
      formElements={formElements}
      onSaveClick={onSave}
      uploadCategory={FileUploadCategory.FUTURE}
    />
  );
}
